import * as React from 'react';

import * as styles from './styles.css';

interface INewReviewModalFooterProps {
  next: React.ReactElement;
  prev: React.ReactElement | null;
}

export const NewReviewModalFooter = ({ next, prev }: INewReviewModalFooterProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['button']}>{prev}</div>
      <div className={styles['button']}>{next}</div>
    </div>
  );
};
